import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useArticleStore } from "@/stores/articleStore";
import { Trash2, AlertTriangle } from "lucide-react";

interface ModalDeleteArticleProps {
  isOpen: boolean;
  onClose: () => void;
  onComplete: () => void;
}

export function ModalDeleteArticle({
  isOpen,
  onClose,
  onComplete,
}: ModalDeleteArticleProps) {
  const { selectedArticle, deleteArticle, isDeleting } = useArticleStore();

  const handleDelete = async () => {
    if (!selectedArticle) return;

    try {
      await deleteArticle(selectedArticle._id);
      onComplete();
    } catch (error) {
      console.error("Error deleting article:", error);
    }
  };

  if (!selectedArticle) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-red-600">
            <AlertTriangle className="w-5 h-5" />
            Xác nhận xóa bài viết
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <div className="flex items-start gap-3 p-3 bg-red-50 rounded-lg">
            <Trash2 className="w-5 h-5 text-red-600 mt-0.5" />
            <div>
              <p className="font-medium text-gray-900">
                Bạn có chắc chắn muốn xóa bài viết này?
              </p>
              <p className="text-sm text-gray-600 mt-1">
                Hành động này không thể hoàn tác.
              </p>
            </div>
          </div>

          <div className="bg-gray-50 p-3 rounded-lg">
            <h4 className="font-medium text-gray-900 mb-2">
              Thông tin bài viết:
            </h4>
            <div className="text-sm text-gray-600 space-y-1">
              <p>
                <span className="font-medium">Tiêu đề:</span>{" "}
                {selectedArticle.title}
              </p>
              <p>
                <span className="font-medium">Tác giả:</span>{" "}
                {selectedArticle?.author?.name || "(Trống)"}
              </p>
              <p>
                <span className="font-medium">Trạng thái:</span>{" "}
                {selectedArticle.status}
              </p>
              <p>
                <span className="font-medium">Lượt xem:</span>{" "}
                {selectedArticle.viewCount}
              </p>
            </div>
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={isDeleting}>
            Hủy
          </Button>
          <Button
            variant="destructive"
            onClick={handleDelete}
            disabled={isDeleting}
            className="cursor-pointer"
          >
            {isDeleting ? (
              <>
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                Đang xóa...
              </>
            ) : (
              <>
                <Trash2 className="w-4 h-4 mr-2" />
                Xóa bài viết
              </>
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
